export default {
  //first page
  'collection.title': 'Quản lý bộ sưu tập',
  'collection.table.id': 'Mã bộ sưu tập',
  'collection.table.name': 'Tên bộ sưu tập',
  'collection.table.itemQuantity': 'Số vật phẩm có trong bst',
  'collection.table.duration': 'Thời hạn sử dụng',
  'collection.table.status': 'Trạng thái hoạt động',

  'collection.filter.status': 'Trạng thái hoạt động',
  'collection.filter.bussiness-status.param':
    '{status,select, 1 {Đang kinh doanh} 2 {Chưa kinh doanh} 3 {Đã kết thúc} other {Không xác định}}',
  'collection.filter.status--available': 'Đang kinh doanh',
  'collection.filter.status--unavailable': 'Chưa kinh doanh',
  'collection.filter.status--conclude': 'Đã kết thúc',

  'collection.delete.title': 'Xóa bộ sưu tập',
  'collection.delete.content': 'Bạn có chắc chắn xóa bộ sưu tập này?',
  //add/edit page
  'updateCollection.title': 'Cập nhật bộ sưu tập',
  'addCollection.title': 'Thêm bộ sưu tập',
  'addCollection.id': 'Mã bộ sưu tập',
  'addCollection.name': 'Tên bộ sưu tập',
  'addCollection.duration': 'Thời hạn',
  'addCollection.duration.message': 'Vui lòng chọn ngày',
  'addCollection.loopType': 'Khung giờ áp dụng',
  'addCollection.loopType--no': 'Cả ngày',
  'addCollection.loopType--yes': 'Theo khung giờ',
  'addCollection.repeat.message': 'Vui lòng chọn thời gian',
  'addCollection.repeat.button': 'Thêm khung giờ',
  'addCollection.loopType.overlapWarn': 'Có sự trùng lặp giữa các khoảng lặp lại',
  'addCollection.loopType.endTimeWarn': 'Giờ kết thúc phải sau giờ bắt đầu',
  //info page
  'collectionInfo.title': 'Thông tin bộ sưu tập',
  'collectionInfo.id': 'Mã bộ sưu tập',
  'collectionInfo.name': 'Tên bộ sưu tập',
  'collectionInfo.duration': 'Thời hạn',
  'collectionInfo.loopType': 'Lặp lại theo ngày',
  'collectionInfo.itemQuantity': 'Số vật phẩm',
  'collectionInfo.to': 'đến',
};
